import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { router } from './router'
import { AuthProvider } from './lib/auth'

// Add error handling
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error)
})

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason)
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <RouterProvider 
        router={router} 
        defaultErrorComponent={({ error }) => {
          console.error('Router error:', error)
          return (
            <div style={{ padding: '2rem', color: 'red' }}>
              <h1>Error</h1>
              <pre>{error?.message || 'Unknown error'}</pre>
              <pre>{error?.stack}</pre>
            </div>
          )
        }}
      />
    </AuthProvider>
  </StrictMode>,
)
